import MerchandiseSearchFormResultItem from './MerchandiseSearchFormResultItem'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ListItemLoadingSkeleton from 'LuxKit/List/ListItemLoadingSkeleton'
import Caption from 'LuxKit/Typography/Caption'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { take } from 'lib/array/arrayUtils'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const ResultsGrid = styled.div`
  display: grid;

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
    gap: ${rem(40)}
  }
`

interface Props {
  text?: string;
  results: App.MerchandiseSearchTypeahead;
  loading?: boolean;
}

function MerchandiseSearchFormResults(props: Props) {
  const { results, text, loading } = props

  return <VerticalSpacer gap={24}>
    {text && <Caption variant="large" weight="bold">Results for "{text}"</Caption>}
    <VerticalSpacer gap={8}>
      <Caption variant="large" weight="bold">Recommended products</Caption>
      <ResultsGrid>
        {loading && <>
          <ListItemLoadingSkeleton />
          <ListItemLoadingSkeleton />
          <ListItemLoadingSkeleton />
        </>}
        {take(results.products, 3).map(product => (
          <MerchandiseSearchFormResultItem
            key={product.id}
            itemId={product.id}
            type="product"
          />
        ))}
      </ResultsGrid>
    </VerticalSpacer>
    <VerticalSpacer gap={8}>
      <Caption variant="large" weight="bold">Recommended categories</Caption>
      <ResultsGrid>
        {loading && <>
          <ListItemLoadingSkeleton />
          <ListItemLoadingSkeleton />
          <ListItemLoadingSkeleton />
        </>}
        {take(results.categories, 3).map(category => (
          <MerchandiseSearchFormResultItem
            key={category.id}
            itemId={category.id}
            type="category"
          />
        ))}
      </ResultsGrid>
    </VerticalSpacer>
    <VerticalSpacer gap={8}>
      <Caption variant="large" weight="bold">Recommended brands</Caption>
      <ResultsGrid>
        {loading && <>
          <ListItemLoadingSkeleton />
          <ListItemLoadingSkeleton />
          <ListItemLoadingSkeleton />
        </>}
        {take(results.brands, 3).map(brand => (
          <MerchandiseSearchFormResultItem
            key={brand.id}
            itemId={brand.id}
            type="brand"
          />
        ))}
      </ResultsGrid>
    </VerticalSpacer>
  </VerticalSpacer>
}

export default MerchandiseSearchFormResults
